module.exports = "<router-outlet></router-outlet>\r\n<router-outlet name=\"print\"></router-outlet>\r\n"